import React, { Suspense } from "react";
import { BrowserView, MobileView } from "react-device-detect";

import Slider from "./slider";
import PopularCities from "./PopularCities";
import PropertiesSlider from './PropertiesSlider'

import "./styles.scss";
import "../../components/Footer/footer.scss";
import SliderForm from "./SliderForm";

import api from "../../api";
import { Helmet } from "react-helmet";
import { setRefId } from "../../helpers/cookie";

import * as images from "./MobileSliderPhoto";

import { useHistory } from "react-router-dom";
import LocationGroups from "./LocationGroups";
import PropertyTypes from "./PropertyTypes";

// const PropertiesSlider = React.lazy(() => import("./PropertiesSlider"));

const Home = ({ }) => {
  const [data, setData] = React.useState([]);
  const [showMore, setShowMore] = React.useState(false);

  const toggleSaleContent = () => {
    setShowMore(!showMore);
  };

  const history = useHistory();
  const locationPathName = window.location.pathname;

  if (locationPathName.includes("detail")) {
    debugger;
    let url = window.location.href;
    let ref = url.split("?ref=");

    if (ref.length > 1) {
      setRefId(ref[1]);
    }

    history.push({
      pathname: `${locationPathName}/1`,
    });
  }

  React.useEffect(() => {
    const script = document.createElement("script");
    script.async = true;

    script.type = "application/ld+json";

    const codeStr = `
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    "name": "Easy Sale",
    "image": "https://www.easysale.com.mt/img/logo-orange01.png",
    "@id": "",
    "url": "https://www.easysale.com.mt/",
    "telephone": "99998330",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "420 Triq D'Argens",
      "addressLocality": "Gżira",
      "postalCode": "",
      "addressCountry": "MT"
    } ,
    "sameAs": [
      "https://www.facebook.com/easysalemalta",
      "https://www.instagram.com/easysale.malta"
    ] 
`;
    script.innerHTML = codeStr;

    document.body.appendChild(script);

    let url = window.location.href;
    let ref = url.split("?ref=");

    if (ref.length > 1) {
      setRefId(ref[1]);
    }
  }, []);

  React.useEffect(async () => {
    const res = await api.home.home();
    if (res?.result) {
      setData(res.result);
    }
  }, []);

  return (
    <div style={{ paddingBottom: "50px" }}>
      <Helmet>
        <title property="title">Easy Sale Malta - Expert Property Sales & Real Estate Services</title>
        <meta name="description" content="Discover your ideal property in Malta with Easy Sale, your trusted partner in real estate. Whether buying or selling, we offer personalized support and a professional team to help you navigate Malta’s property market with ease." />
        <meta name="keywords" content="apartment for sale, sale in malta, real estate in malta, accommodation in malta, residential apartments, commercial apartments, commercial property, property for sale" />
      </Helmet>

      <Suspense>
        <div className="home-slider">
          <BrowserView>
            <Suspense>
              <Slider />
            </Suspense>
          </BrowserView>
          <MobileView>
            {/* <div style={{ display: 'flex', justifyContent: 'center', padding: 20, backgroundImage: `url('/img/slider3.jpg')` }}>
            <SliderForm />
          </div> */}
            <div style={{ height: 500 }}>
              <img
                rel="preload"
                alt="img-mobile-slider"
                as="image"
                src={images.slider100}
                style={{ height: "500px" }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "2%",
                  right: "10%",
                  zIndex: 1,
                }}
              >
                <SliderForm />
              </div>
            </div>
          </MobileView>
        </div>
      </Suspense>

      <div style={{ margin: "20px auto", backgroundColor: "#f5f5f5", border: "2px solid #fe7516", borderRadius: "10px", textAlign: "center", boxShadow: "0 4px 10px rgba(0,0,0,0.05)", padding: "25px", maxWidth: "1200px" }}>
        <h1 style={{ fontWeight: 700, color: "#444", fontSize: "30px", marginBottom: "10px" }}>  Apartment for Sale </h1>
        <div style={{ margin: "15px 0" }}>
          <h2 style={{ fontWeight: 600, display: "inline-block", padding: "0 8px", color: "#555", fontSize: "20px" }}>
            Sale in Malta
          </h2>
          <h2 style={{ fontWeight: 600, display: "inline-block", padding: "0 8px", color: "#555", fontSize: "20px" }}>
            Real Estate in Malta
          </h2>
        </div>
        <p style={{ fontSize: "16px", color: "#555", marginTop: "10px" }}>
          Discover modern apartments for sale in Malta with excellent locations, high investment potential, and trusted real estate services to help you find the perfect property.
        </p>
        <p style={{ fontWeight: "bold", fontSize: "22px", marginTop: "20px" }}>
          <a href="tel:99998330" style={{ color: "#fe7516", textDecoration: "none" }}>
            Call Now! 99998330
          </a>
        </p>
      </div>

      <Suspense fallback={<div>loading...</div>}>
        <PopularCities />
      </Suspense>

      <Suspense fallback={<div>loading...</div>}>
        <LocationGroups />
      </Suspense>

      <Suspense fallback={<div>loading...</div>}>
        <PropertyTypes />
      </Suspense>

      <Suspense fallback={<div>loading...</div>}>
        <PropertiesSlider data={data} />
      </Suspense>

      <div style={{ margin: "30px auto", background: "#f6f6f6", border: "2px solid #dcdcdc", borderRadius: "10px", padding: "25px", maxWidth: "1200px", lineHeight: "1.6", fontFamily: "Arial,Helvetica,sans-serif" }}>
        <h3 style={{ fontSize: "24px", marginBottom: "15px", color: "#333" }}>Apartment for Sale and Property Investment Opportunities in Malta</h3>
        <div id="seoSaleContent" style={{ maxHeight: showMore ? "2000px" : "220px", overflow: "hidden", transition: "all .4s ease", fontSize: "15px", color: "#444" }}>
          <p>Malta has rapidly become one of the most attractive destinations in Europe for property buyers and international investors. The demand for <strong>apartment for sale</strong> listings continues to grow thanks to Malta’s strong economy, Mediterranean lifestyle, and stable real estate market. Whether you are looking for a modern residence, a holiday home, or a long-term investment, exploring <strong>sale in Malta</strong> opportunities can provide excellent value and long-term potential.</p>
          <p>The property sector offers a wide range of choices including modern apartments, luxury penthouses, traditional townhouses, and exclusive villas. With increasing international interest, <strong>real estate in Malta</strong> remains one of the most stable and promising property markets in the Mediterranean region.</p>
          <h4 style={{ fontSize: "20px", marginTop: "20px", color: "#333" }}>Why Buy an Apartment for Sale in Malta?</h4>
          <p>Investing in an <strong>apartment for sale</strong> in Malta provides both lifestyle benefits and financial opportunities. Many buyers are attracted to the island due to its strategic location in the Mediterranean, excellent infrastructure, and vibrant international community. From seafront apartments to city-center residences, Malta offers a wide variety of properties suitable for different budgets and investment strategies.</p>
          <p>Buyers looking for <strong>sale in Malta</strong> properties often benefit from rising property values and strong rental demand, making it a popular market for both investors and homeowners.</p>
          <h4 style={{ fontSize: "20px", marginTop: "20px", color: "#333" }}>Real Estate in Malta: A Growing Market</h4>
          <p>The demand for <strong>real estate in Malta</strong> has grown steadily over the past decade. International companies, remote workers, and entrepreneurs continue to relocate to Malta, increasing the demand for high-quality housing and modern living spaces.</p>
          <p>As a result, the market for <strong>property for sale</strong> offers excellent opportunities for buyers who are seeking both residential comfort and long-term investment potential. Properties located near the coast, business districts, and tourism centers are particularly attractive.</p>
          <h4 style={{ fontSize: "20px", marginTop: "20px", color: "#333" }}>Accommodation in Malta for Investors and Residents</h4>
          <p>Purchasing property also allows owners to benefit from the strong rental demand in Malta. Many investors buy <strong>property for sale</strong> and later rent it out as <strong>long lets apartments</strong> or <strong>short lets apartments</strong>. This approach allows property owners to generate stable rental income while benefiting from long-term capital growth.</p>
          <p>For residents, owning <strong>accommodation in Malta</strong> means enjoying a comfortable Mediterranean lifestyle, excellent climate, and easy access to international travel connections.</p>
          <h4 style={{ fontSize: "20px", marginTop: "20px", color: "#333" }}>Long Lets Apartments and Rental Investment</h4>
          <p>Many investors purchase an <strong>apartment for sale</strong> with the intention of renting it as <strong>long lets apartments</strong>. Long-term rentals are particularly popular among expatriates, professionals, and international workers who plan to live in Malta for extended periods.</p>
          <p>Properties located in areas such as Sliema, St. Julian’s, and Valletta often provide strong rental demand and stable income for property owners.</p>
          <h4 style={{ fontSize: "20px", marginTop: "20px", color: "#333" }}>Short Lets Apartments for Tourism Income</h4>
          <p>Malta’s thriving tourism sector also makes <strong>short lets apartments</strong> a profitable option for property investors. Tourists prefer fully furnished apartments that provide flexibility and privacy compared to traditional hotels.</p>
          <p>Owning an apartment that can be used for <strong>short lets apartments</strong> rentals allows investors to benefit from seasonal tourism demand while maintaining ownership of a valuable property asset.</p>
          <h4 style={{ fontSize: "20px", marginTop: "20px", color: "#333" }}>Commercial Property Opportunities</h4>
          <p>Beyond residential properties, the demand for <strong>commercial property</strong> in Malta continues to grow as the island attracts new businesses and international companies. Retail stores, office spaces, and hospitality venues represent valuable investment opportunities.</p>
          <p>Investing in <strong>commercial property</strong> can provide high rental yields and long-term financial growth, especially in high-traffic commercial areas and business districts.</p>
          <h4 style={{ fontSize: "20px", marginTop: "20px", color: "#333" }}>Find the Best Property for Sale in Malta</h4>
          <p>Whether you are searching for a dream home or planning a strategic investment, exploring <strong>property for sale</strong> listings in Malta opens the door to numerous opportunities. From modern city apartments to luxurious seaside residences, buyers can find properties that match their lifestyle and financial goals.</p>
          <p>The strong demand for <strong>real estate in Malta</strong>, combined with the island’s exceptional quality of life, makes Malta one of the most appealing locations in Europe for property ownership and investment.</p>
        </div>
        <div style={{ textAlign: "center", marginTop: "15px" }}>
          <button onClick={toggleSaleContent} id="saleReadBtn" style={{ background: "#333", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "6px", cursor: "pointer", fontSize: "14px" }}>
            {showMore ? "Kapat" : "Devamını Oku"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
